import type { PublicSlotKey } from '#packages/apilib';
import type { ContentInjectionApi } from './contentInjectionApi';

export const ContentInjectionApiKey: PublicSlotKey<ContentInjectionApi> = {
  name: 'ContentInjectionApi',
  public: true,
};
